import { render, staticRenderFns } from "./Polaroid.vue?vue&type=template&id=7cb54843&scoped=true&"
import script from "./Polaroid.vue?vue&type=script&lang=ts&"
export * from "./Polaroid.vue?vue&type=script&lang=ts&"
import style0 from "./Polaroid.vue?vue&type=style&index=0&id=7cb54843&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb54843",
  null
  
)

export default component.exports